import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';

const ExamDocument = ({ data, classroom, month, year }) => {

    const capitalWord = (str) => {
        if (str) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            return splitStr.join(' ');
        }
        else {
            return splitStr
        }
    };

    const filterGrade = (type, value) => {
        if (type === "D1" || type === "D2" || type === "D3" || type === "D4" || type === "D5" || type === "D6") {
            return filterGradeUPSR(value)
        }
        if (type === "F1" || type === "F2" || type === "F3") {
            return filterGradePMR(value)
        }
        if (type === "F4" || type === "F5") {
            return filterGradeSPM(value)
        }
        else {
            return null
        }
    };

    const filterGradeUPSR = (value) => {
        if (value === "") {
            return "-"
        }
        if (value >= 0 && value <= 39) {
            return "E"
        }
        if (value >= 40 && value <= 49) {
            return "D"
        }
        if (value >= 50 && value <= 64) {
            return "C"
        }
        if (value >= 65 && value <= 79) {
            return "B"
        }
        if (value >= 80 && value <= 100) {
            return "A"
        }
        if (value === "TH" || value === "th") {
            return value
        }
        else {
            return "-"
        }
    };

    const filterGradePMR = (value) => {
        if (value === "") {
            return "-"
        }
        if (value >= 0 && value <= 39) {
            return "F"
        }
        if (value >= 40 && value <= 49) {
            return "E"
        }
        if (value >= 50 && value <= 59) {
            return "D"
        }
        if (value >= 60 && value <= 69) {
            return "C"
        }
        if (value >= 70 && value <= 84) {
            return "B"
        }
        if (value >= 85 && value <= 100) {
            return "A"
        }
        if (value === "TH" || value === "th") {
            return value
        }
        else {
            return "-"
        }
    };

    const filterGradeSPM = (value) => {
        if (value === "") {
            return "-"
        }
        if (value >= 0 && value <= 39) {
            return "G"
        }
        if (value >= 40 && value <= 44) {
            return "E"
        }
        if (value >= 45 && value <= 49) {
            return "D"
        }
        if (value >= 50 && value <= 54) {
            return "C"
        }
        if (value >= 55 && value <= 59) {
            return "C+"
        }
        if (value >= 60 && value <= 64) {
            return "B"
        }
        if (value >= 65 && value <= 69) {
            return "B+"
        }
        if (value >= 70 && value <= 79) {
            return "A-"
        }
        if (value >= 80 && value <= 89) {
            return "A"
        }
        if (value >= 90 && value <= 100) {
            return "A+"
        }
        if (value === "TH" || value === "th") {
            return value
        }
        else {
            return "-"
        }
    };

    const filterResult = (bm, bi, sn, mt) => {
        if (((
            ((bm === "TH" || bm === "" || !bm) ? 0 : parseInt(bm))
            + ((bi === "TH" || bi === "" || !bi) ? 0 : parseInt(bi))
            + ((mt === "TH" || mt === "" || !mt) ? 0 : parseInt(mt))
            + ((sn === "TH" || sn === "" || !sn) ? 0 : parseInt(sn))
        ) / (
                ((bm === "TH" || bm === "" || !bm) ? 0 : 1)
                + ((bi === "TH" || bi === "" || !bi) ? 0 : 1)
                + ((mt === "TH" || mt === "" || !mt) ? 0 : 1)
                + ((sn === "TH" || sn === "" || !sn) ? 0 : 1)
            )) > 40) {
            return "Pass"
        }
        else {
            return "Fail"
        }
    };

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {
                    data.map((val, i) => (
                        <View key={i} style={{ height: "33%", paddingTop: "10px", alignItems: "center", justifyContent: "center", borderTop: '1px solid #EEEEEE', borderBottom: '1px solid #EEEEEE' }}>
                            <Text style={{ fontSize: 10, width: "100%", textAlign: "center" }}>Exam Slip</Text>

                            <View style={{ flexDirection: "row", alignItems: "center", alignSelf: "flex-start" }}>
                                <View style={{}}>
                                    <Image source={require('../../images/PTGM-Logo.png')} style={{ width: 50, objectFit: "contain" }} />
                                </View>
                                <View style={{ paddingHorizontal: "15px" }}>
                                    <Text style={{ fontSize: 8 }}>PUSAT TUISYEN GENIUS MILENIA</Text>
                                    <Text style={{ fontSize: 8 }}>NO 1, 1, Jalan PJS 5/30, Taman Medan, 46000 </Text>
                                    <Text style={{ fontSize: 8 }}>Petaling Jaya, Selangor</Text>
                                </View>
                            </View>

                            <View style={{ flexDirection: "row", flexWrap: "wrap", marginVertical: "15px" }}>
                                <Text style={{ fontSize: 8, width: "50%" }}>Name: {capitalWord(val.Student_Name)}</Text>
                                <Text style={{ fontSize: 8, width: "50%" }}>Exam: {year}</Text>
                                <Text style={{ fontSize: 8, width: "50%" }}>Standard/Form: {capitalWord(classroom)}</Text>
                            </View>

                            <View style={styles.table}>
                                <View style={[styles.row, styles.bold, styles.header]}>
                                    <Text style={styles.colSubject}>Subject</Text>
                                    <Text style={styles.colMarks}>Quiz{`\n`}1</Text>
                                    <Text style={styles.colGrades}>Grade</Text>
                                    <Text style={styles.colMarks}>Quiz{`\n`}2</Text>
                                    <Text style={styles.colGrades}>Grade</Text>
                                    <Text style={styles.colMarks}>Quiz{`\n`}3</Text>
                                    <Text style={styles.colGrades}>Grade</Text>
                                    <Text style={styles.colMarks}>Quiz{`\n`}4</Text>
                                    <Text style={styles.colGrades}>Grade</Text>
                                    {/* <Text style={styles.colMarks}>Quiz{`\n`}5</Text>
                                    <Text style={styles.colGrades}>Grade</Text> */}
                                    <Text style={styles.colMarks}>Exam{`\n`}1</Text>
                                    <Text style={styles.colGrades}>Grade</Text>
                                </View>
                                <View style={styles.row} wrap={false}>
                                    <Text style={styles.colSubject}>B. Melayu</Text>
                                    <Text style={styles.colMarks}>{(val.K1_Bahasa_Melayu && val.K1_Bahasa_Melayu === "TH") ? "TH" : val.K1_Bahasa_Melayu ? `${val.K1_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Bahasa_Melayu)}</Text>
                                    <Text style={styles.colMarks}>{(val.K2_Bahasa_Melayu && val.K2_Bahasa_Melayu === "TH") ? "TH" : val.K2_Bahasa_Melayu ? `${val.K2_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Bahasa_Melayu)}</Text>
                                    <Text style={styles.colMarks}>{(val.K3_Bahasa_Melayu && val.K3_Bahasa_Melayu === "TH") ? "TH" : val.K3_Bahasa_Melayu ? `${val.K3_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Bahasa_Melayu)}</Text>
                                    <Text style={styles.colMarks}>{(val.K4_Bahasa_Melayu && val.K4_Bahasa_Melayu === "TH") ? "TH" : val.K4_Bahasa_Melayu ? `${val.K4_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Bahasa_Melayu)}</Text>
                                    {/* <Text style={styles.colMarks}>{(val.K5_Bahasa_Melayu && val.K5_Bahasa_Melayu === "TH") ? "TH" : val.K5_Bahasa_Melayu ? `${val.K5_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Bahasa_Melayu)}</Text>
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Bahasa_Melayu && val.K6_Bahasa_Melayu === "TH") ? "TH" : val.K6_Bahasa_Melayu ? `${val.K6_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Bahasa_Melayu)}</Text> */}
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Bahasa_Melayu && val.K5_Bahasa_Melayu === "TH") ? "TH" : val.K5_Bahasa_Melayu ? `${val.K5_Bahasa_Melayu}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Bahasa_Melayu)}</Text>
                                </View>
                                <View style={styles.row} wrap={false}>
                                    <Text style={styles.colSubject}>English</Text>
                                    <Text style={styles.colMarks}>{(val.K1_Bahasa_Inggeris && val.K1_Bahasa_Inggeris === "TH") ? "TH" : val.K1_Bahasa_Inggeris ? `${val.K1_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Bahasa_Inggeris)}</Text>
                                    <Text style={styles.colMarks}>{(val.K2_Bahasa_Inggeris && val.K2_Bahasa_Inggeris === "TH") ? "TH" : val.K2_Bahasa_Inggeris ? `${val.K2_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Bahasa_Inggeris)}</Text>
                                    <Text style={styles.colMarks}>{(val.K3_Bahasa_Inggeris && val.K3_Bahasa_Inggeris === "TH") ? "TH" : val.K3_Bahasa_Inggeris ? `${val.K3_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Bahasa_Inggeris)}</Text>
                                    <Text style={styles.colMarks}>{(val.K4_Bahasa_Inggeris && val.K4_Bahasa_Inggeris === "TH") ? "TH" : val.K4_Bahasa_Inggeris ? `${val.K4_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Bahasa_Inggeris)}</Text>
                                    {/* <Text style={styles.colMarks}>{(val.K5_Bahasa_Inggeris && val.K5_Bahasa_Inggeris === "TH") ? "TH" : val.K5_Bahasa_Inggeris ? `${val.K5_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Bahasa_Inggeris)}</Text>
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Bahasa_Inggeris && val.K6_Bahasa_Inggeris === "TH") ? "TH" : val.K6_Bahasa_Inggeris ? `${val.K6_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Bahasa_Inggeris)}</Text> */}
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Bahasa_Inggeris && val.K5_Bahasa_Inggeris === "TH") ? "TH" : val.K5_Bahasa_Inggeris ? `${val.K5_Bahasa_Inggeris}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Bahasa_Inggeris)}</Text>
                                </View>
                                <View style={styles.row} wrap={false}>
                                    <Text style={styles.colSubject}>Mathematic</Text>
                                    <Text style={styles.colMarks}>{(val.K1_Matematik && val.K1_Matematik === "TH") ? "TH" : val.K1_Matematik ? `${val.K1_Matematik}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Matematik)}</Text>
                                    <Text style={styles.colMarks}>{(val.K2_Matematik && val.K2_Matematik === "TH") ? "TH" : val.K2_Matematik ? `${val.K2_Matematik}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Matematik)}</Text>
                                    <Text style={styles.colMarks}>{(val.K3_Matematik && val.K3_Matematik === "TH") ? "TH" : val.K3_Matematik ? `${val.K3_Matematik}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Matematik)}</Text>
                                    <Text style={styles.colMarks}>{(val.K4_Matematik && val.K4_Matematik === "TH") ? "TH" : val.K4_Matematik ? `${val.K4_Matematik}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Matematik)}</Text>
                                    {/* <Text style={styles.colMarks}>{(val.K5_Matematik && val.K5_Matematik === "TH") ? "TH" : val.K5_Matematik ? `${val.K5_Matematik}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Matematik)}</Text>
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Matematik && val.K6_Matematik === "TH") ? "TH" : val.K6_Matematik ? `${val.K6_Matematik}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Matematik)}</Text> */}
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Matematik && val.K5_Matematik === "TH") ? "TH" : val.K5_Matematik ? `${val.K5_Matematik}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Matematik)}</Text>
                                </View>
                                <View style={styles.row} wrap={false}>
                                    <Text style={styles.colSubject}>Science</Text>
                                    <Text style={styles.colMarks}>{(val.K1_Sains && val.K1_Sains === "TH") ? "TH" : val.K1_Sains ? `${val.K1_Sains}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Sains)}</Text>
                                    <Text style={styles.colMarks}>{(val.K2_Sains && val.K2_Sains === "TH") ? "TH" : val.K2_Sains ? `${val.K2_Sains}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Sains)}</Text>
                                    <Text style={styles.colMarks}>{(val.K3_Sains && val.K3_Sains === "TH") ? "TH" : val.K3_Sains ? `${val.K3_Sains}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Sains)}</Text>
                                    <Text style={styles.colMarks}>{(val.K4_Sains && val.K4_Sains === "TH") ? "TH" : val.K4_Sains ? `${val.K4_Sains}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Sains)}</Text>
                                    {/* <Text style={styles.colMarks}>{(val.K5_Sains && val.K5_Sains === "TH") ? "TH" : val.K5_Sains ? `${val.K5_Sains}%` : "-"}</Text>
                                    <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Sains)}</Text>
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Sains && val.K6_Sains === "TH") ? "TH" : val.K6_Sains ? `${val.K6_Sains}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Sains)}</Text> */}
                                    <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Sains && val.K5_Sains === "TH") ? "TH" : val.K5_Sains ? `${val.K5_Sains}%` : "-"}</Text>
                                    <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Sains)}</Text>
                                </View>
                                {
                                    (classroom === "F1" || classroom === "F2" || classroom === "F3" || classroom === "F4" || classroom === "F5") && val.K5_Sejarah &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Sejarah</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Sejarah && val.K1_Sejarah === "TH") ? "TH" : val.K1_Sejarah ? `${val.K1_Sejarah}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Sejarah)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Sejarah && val.K2_Sejarah === "TH") ? "TH" : val.K2_Sejarah ? `${val.K2_Sejarah}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Sejarah)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Sejarah && val.K3_Sejarah === "TH") ? "TH" : val.K3_Sejarah ? `${val.K3_Sejarah}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Sejarah)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Sejarah && val.K4_Sejarah === "TH") ? "TH" : val.K4_Sejarah ? `${val.K4_Sejarah}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Sejarah)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Sejarah && val.K5_Sejarah === "TH") ? "TH" : val.K5_Sejarah ? `${val.K5_Sejarah}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Sejarah)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Sejarah && val.K6_Sejarah === "TH") ? "TH" : val.K6_Sejarah ? `${val.K6_Sejarah}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Sejarah)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Sejarah && val.K5_Sejarah === "TH") ? "TH" : val.K5_Sejarah ? `${val.K5_Sejarah}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Sejarah)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Akaun &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Akaun</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Akaun && val.K1_Akaun === "TH") ? "TH" : val.K1_Akaun ? `${val.K1_Akaun}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Akaun)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Akaun && val.K2_Akaun === "TH") ? "TH" : val.K2_Akaun ? `${val.K2_Akaun}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Akaun)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Akaun && val.K3_Akaun === "TH") ? "TH" : val.K3_Akaun ? `${val.K3_Akaun}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Akaun)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Akaun && val.K4_Akaun === "TH") ? "TH" : val.K4_Akaun ? `${val.K4_Akaun}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Akaun)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Akaun && val.K5_Akaun === "TH") ? "TH" : val.K5_Akaun ? `${val.K5_Akaun}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Akaun)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Akaun && val.K6_Akaun === "TH") ? "TH" : val.K6_Akaun ? `${val.K6_Akaun}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Akaun)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Akaun && val.K5_Akaun === "TH") ? "TH" : val.K5_Akaun ? `${val.K5_Akaun}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Akaun)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Add_Math &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Add Math</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Add_Math && val.K1_Add_Math === "TH") ? "TH" : val.K1_Add_Math ? `${val.K1_Add_Math}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Add_Math)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Add_Math && val.K2_Add_Math === "TH") ? "TH" : val.K2_Add_Math ? `${val.K2_Add_Math}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Add_Math)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Add_Math && val.K3_Add_Math === "TH") ? "TH" : val.K3_Add_Math ? `${val.K3_Add_Math}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Add_Math)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Add_Math && val.K4_Add_Math === "TH") ? "TH" : val.K4_Add_Math ? `${val.K4_Add_Math}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Add_Math)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Add_Math && val.K5_Add_Math === "TH") ? "TH" : val.K5_Add_Math ? `${val.K5_Add_Math}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Add_Math)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Add_Math && val.K6_Add_Math === "TH") ? "TH" : val.K6_Add_Math ? `${val.K6_Add_Math}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Add_Math)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Add_Math && val.K5_Add_Math === "TH") ? "TH" : val.K5_Add_Math ? `${val.K5_Add_Math}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Add_Math)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Biologi &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Biologi</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Biologi && val.K1_Biologi === "TH") ? "TH" : val.K1_Biologi ? `${val.K1_Biologi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Biologi)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Biologi && val.K2_Biologi === "TH") ? "TH" : val.K2_Biologi ? `${val.K2_Biologi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Biologi)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Biologi && val.K3_Biologi === "TH") ? "TH" : val.K3_Biologi ? `${val.K3_Biologi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Biologi)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Biologi && val.K4_Biologi === "TH") ? "TH" : val.K4_Biologi ? `${val.K4_Biologi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Biologi)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Biologi && val.K5_Biologi === "TH") ? "TH" : val.K5_Biologi ? `${val.K5_Biologi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Biologi)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Biologi && val.K6_Biologi === "TH") ? "TH" : val.K6_Biologi ? `${val.K6_Biologi}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Biologi)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Biologi && val.K5_Biologi === "TH") ? "TH" : val.K5_Biologi ? `${val.K5_Biologi}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Biologi)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Kimia &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Kimia</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Kimia && val.K1_Kimia === "TH") ? "TH" : val.K1_Kimia ? `${val.K1_Kimia}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Kimia)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Kimia && val.K2_Kimia === "TH") ? "TH" : val.K2_Kimia ? `${val.K2_Kimia}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Kimia)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Kimia && val.K3_Kimia === "TH") ? "TH" : val.K3_Kimia ? `${val.K3_Kimia}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Kimia)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Kimia && val.K4_Kimia === "TH") ? "TH" : val.K4_Kimia ? `${val.K4_Kimia}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Kimia)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Kimia && val.K5_Kimia === "TH") ? "TH" : val.K5_Kimia ? `${val.K5_Kimia}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Kimia)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Kimia && val.K6_Kimia === "TH") ? "TH" : val.K6_Kimia ? `${val.K6_Kimia}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Kimia)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Kimia && val.K5_Kimia === "TH") ? "TH" : val.K5_Kimia ? `${val.K5_Kimia}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Kimia)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Fizik &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Fizik</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Fizik && val.K1_Fizik === "TH") ? "TH" : val.K1_Fizik ? `${val.K1_Fizik}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Fizik)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Fizik && val.K2_Fizik === "TH") ? "TH" : val.K2_Fizik ? `${val.K2_Fizik}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Fizik)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Fizik && val.K3_Fizik === "TH") ? "TH" : val.K3_Fizik ? `${val.K3_Fizik}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Fizik)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Fizik && val.K4_Fizik === "TH") ? "TH" : val.K4_Fizik ? `${val.K4_Fizik}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Fizik)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Fizik && val.K5_Fizik === "TH") ? "TH" : val.K5_Fizik ? `${val.K5_Fizik}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Fizik)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Fizik && val.K6_Fizik === "TH") ? "TH" : val.K6_Fizik ? `${val.K6_Fizik}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Fizik)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Fizik && val.K5_Fizik === "TH") ? "TH" : val.K5_Fizik ? `${val.K5_Fizik}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Fizik)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Ekonomi &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Ekonomi</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Ekonomi && val.K1_Ekonomi === "TH") ? "TH" : val.K1_Ekonomi ? `${val.K1_Ekonomi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Ekonomi)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Ekonomi && val.K2_Ekonomi === "TH") ? "TH" : val.K2_Ekonomi ? `${val.K2_Ekonomi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Ekonomi)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Ekonomi && val.K3_Ekonomi === "TH") ? "TH" : val.K3_Ekonomi ? `${val.K3_Ekonomi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Ekonomi)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Ekonomi && val.K4_Ekonomi === "TH") ? "TH" : val.K4_Ekonomi ? `${val.K4_Ekonomi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Ekonomi)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Ekonomi && val.K5_Ekonomi === "TH") ? "TH" : val.K5_Ekonomi ? `${val.K5_Ekonomi}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Ekonomi)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Ekonomi && val.K6_Ekonomi === "TH") ? "TH" : val.K6_Ekonomi ? `${val.K6_Ekonomi}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Ekonomi)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Ekonomi && val.K5_Ekonomi === "TH") ? "TH" : val.K5_Ekonomi ? `${val.K5_Ekonomi}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Ekonomi)}</Text>
                                    </View>
                                }
                                {
                                    (classroom === "F4" || classroom === "F5") && val.K5_Perniagaan &&
                                    <View style={styles.row} wrap={false}>
                                        <Text style={styles.colSubject}>Perniagaan</Text>
                                        <Text style={styles.colMarks}>{(val.K1_Perniagaan && val.K1_Perniagaan === "TH") ? "TH" : val.K1_Perniagaan ? `${val.K1_Perniagaan}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K1_Perniagaan)}</Text>
                                        <Text style={styles.colMarks}>{(val.K2_Perniagaan && val.K2_Perniagaan === "TH") ? "TH" : val.K2_Perniagaan ? `${val.K2_Perniagaan}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K2_Perniagaan)}</Text>
                                        <Text style={styles.colMarks}>{(val.K3_Perniagaan && val.K3_Perniagaan === "TH") ? "TH" : val.K3_Perniagaan ? `${val.K3_Perniagaan}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K3_Perniagaan)}</Text>
                                        <Text style={styles.colMarks}>{(val.K4_Perniagaan && val.K4_Perniagaan === "TH") ? "TH" : val.K4_Perniagaan ? `${val.K4_Perniagaan}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K4_Perniagaan)}</Text>
                                        {/* <Text style={styles.colMarks}>{(val.K5_Perniagaan && val.K5_Perniagaan === "TH") ? "TH" : val.K5_Perniagaan ? `${val.K5_Perniagaan}%` : "-"}</Text>
                                        <Text style={styles.colGrades}>{filterGrade(classroom, val.K5_Perniagaan)}</Text>
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K6_Perniagaan && val.K6_Perniagaan === "TH") ? "TH" : val.K6_Perniagaan ? `${val.K6_Perniagaan}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K6_Perniagaan)}</Text> */}
                                        <Text style={[styles.colMarks, styles.colExam]}>{(val.K5_Perniagaan && val.K5_Perniagaan === "TH") ? "TH" : val.K5_Perniagaan ? `${val.K5_Perniagaan}%` : "-"}</Text>
                                        <Text style={[styles.colGrades, styles.colExam]}>{filterGrade(classroom, val.K5_Perniagaan)}</Text>
                                    </View>
                                }
                            </View>

                            <View style={{ flexDirection: "row", width: "100%", padding: "10px" }}>
                                <View style={{ width: "30%", alignItems: "center" }}>
                                    <View style={{ borderBottom: '1px solid #888888', height: 25, width: "70%" }} />
                                    <Text style={{ fontSize: 7, textAlign: "center", fontFamily: 'Helvetica' }}>Sign of Parents</Text>
                                </View>
                                <View style={{ width: "30%", alignItems: "center" }}>
                                    <View style={{ borderBottom: '1px solid #888888', height: 25, width: "70%" }} />
                                    <Text style={{ fontSize: 7, textAlign: "center", fontFamily: 'Helvetica' }}>Sign of Coor.Academic</Text>
                                </View>
                                <View style={{ width: "30%", alignItems: "center" }}>
                                    <View style={{ borderBottom: '1px solid #888888', height: 25, width: "70%" }} />
                                    <Text style={{ fontSize: 7, textAlign: "center", fontFamily: 'Helvetica' }}>Sign of Manager</Text>
                                </View>
                            </View>

                        </View>
                    ))
                }
                {/* <Text>{JSON.stringify(data, null, 2)}</Text> */}
            </Page>
        </Document>

    )
};

export default ExamDocument;

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600, fontStyle: "italic" }
    ]
});

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        padding: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    }, table: {
        width: '100%',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        // borderBottom: '1px solid #EEE',
        // borderLeft: '1px solid #EEE',
        // borderRight: '1px solid #EEE',
        // paddingTop: 3,
        // paddingBottom: 3,
        alignItems: "center",
        justifyContent: "center"
    },
    header: {
        borderTop: 'none',
        backgroundColor: "#F7DC6F"
    },
    bold: {
        fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    colSubject: {
        width: '60%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "2px",
        marginLeft: "5px",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    colMarks: {
        width: '30%',
        textAlign: "center",
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "2px",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    colGrades: {
        width: '40%',
        textAlign: "center",
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "2px",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    colResults: {
        width: '20%',
        textAlign: "right",
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px"
    },
    colExam: {
        // backgroundColor: "#EFEFEF",
        // borderTop: '1px solid #EEE',
        // borderBottom: '1px solid #EEE',
        zIndex: -1,
        marginTop: '-1px',
    },
    colPass: {
        width: '15%',
        textAlign: "center",
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px",
        borderBottom: '1px solid #EEE',
    },
    col1: {
        width: '5%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "2px"
    },
    col2: {
        width: '20%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px"
    },
    col3: {
        width: '15%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px"
    },
    col4: {
        width: '10%',
        fontSize: 8,
        fontFamily: 'Helvetica',
        padding: "5px"
    },
})